import ticketApiService from "../../common/services/ticket-api-service";
import { TicketModule } from "../../common/model/ticket/ticket";
import { TicketPaginationValues } from "../../common/model/ticket/ticket-pagination-values";
import { ticketEntity } from "../../common/model/entity/ticket-entity";
import { ticketCommentEntity } from "../../common/model/entity/ticket-comment-entity";
import { commentAttachmentEntity } from "../../common/model/entity/comment-attachment-entity";
import PrototypeInstance from "../../common/helper/prototype-instance";

export async function FillTicketEntity() {
  let tickets: TicketModule.Ticket[] | null = await GetAllTickets();

  if (tickets !== null && tickets.length > 0) {
    await ticketEntity.insert({
      data: tickets,
    });
  }
  //await InsertTestData();
}

export async function AddTicketCommentsToCommentEntity(ticketId: string) {
  /** Wiping the full tables can take noticeable time on IndexedDB; overlap with HTTP. */
  const [, , result] = await Promise.all([
    commentAttachmentEntity.deleteAll(),
    ticketCommentEntity.deleteAll(),
    GetTicketComments(ticketId),
  ]);
  // Every thread's comments are stored; which ones show is decided per conversation tab, and the
  // store's tpcIds / approvalIds now come from `ticket/conversation/cx` (ticket-conversation-tabs.ts)
  // rather than from this response.
  await ticketCommentEntity.insert({
    data: result.comments,
  });
}

function TicketCommentsExist(ticketId: string) {
  let ticketComments = ticketCommentEntity
    .query<any>()
    .where("ticketId", ticketId)
    .all();

  if (ticketComments?.length) return true;

  return false;
}

async function GetTicketComments(ticketId: string) {
  let ticketCommentQuery = {
    TicketId: ticketId,
    PageNumber: 1,
    PageSize: 1,
    GetAll: true,
    IsInternal: false,
    Types: ["Comment", "ThirdPartyConversation", "ApprovalComment"],
    ContactEmail:
      PrototypeInstance.globalProperties.$store.getters[
        "ContactModule/getContactEmail"
      ],
  };

  return await ticketApiService.getTicketComments(ticketId, ticketCommentQuery);
}

async function GetAllTickets(): Promise<TicketModule.Ticket[] | null> {
  let contactId: number =
    PrototypeInstance.globalProperties.$store.getters[
      "ContactModule/getContactId"
    ];
  let clientId: number | null =
    PrototypeInstance.globalProperties.$store.getters[
      "ContactModule/getClientId"
    ];
  let hasAllTicketsTag: boolean =
    PrototypeInstance.globalProperties.$store.getters[
      "ContactModule/getHasAllTicketsTag"
    ];

  let ticketPagination: TicketPaginationValues = new TicketPaginationValues(
    "UpdatedOn",
    true,
    1,
    -1,
    null,
    [],
    ["4", "5", "7"],
    null,
    contactId,
    null,
    null,
    null,
    clientId,
    null,
    false,
    null,
    null,
    null,
    "",
    0,
    hasAllTicketsTag,
  );

  let tickets = await ticketApiService.GetAllTickets(ticketPagination);
  return tickets.content;
}
